/* Shiatsu Store – globale Theme-Skripte */
(function () {
  'use strict';

  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---------- Countdown: funktioniert für JEDEN [data-countdown] auf JEDER Seite ---------- */
  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-countdown]:not([data-cd-ready])');
    if (!nodes.length) return;

    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-cd-ready', '1');

      var hours = parseFloat(el.getAttribute('data-hours') || '4');
      if (!isFinite(hours) || hours <= 0) hours = 4;

      /* Ende wird pro Besucher gespeichert, damit der Countdown beim
         Seitenwechsel (Produkt, Warenkorb, Rechtsseiten) weiterläuft
         und nicht bei jedem Aufruf neu startet. */
      var key = 'shiatsu_deal_end_' + hours;
      var end = 0;
      try { end = parseInt(window.localStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }

      var span = hours * 3600000 + 27 * 60000;
      if (!end || isNaN(end) || end - Date.now() <= 0) {
        end = Date.now() + span;
        try { window.localStorage.setItem(key, String(end)); } catch (e) {}
      }

      var h = el.querySelector('[data-h]');
      var m = el.querySelector('[data-m]');
      var s = el.querySelector('[data-s]');

      function tick() {
        var d = end - Date.now();
        if (d <= 0) {
          /* Aktion neu starten, damit nie 00:00:00 stehen bleibt */
          end = Date.now() + span;
          try { window.localStorage.setItem(key, String(end)); } catch (e) {}
          d = span;
        }
        if (h) h.textContent = pad(Math.floor(d / 3600000));
        if (m) m.textContent = pad(Math.floor((d % 3600000) / 60000));
        if (s) s.textContent = pad(Math.floor((d % 60000) / 1000));
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Live-Besucherzähler ---------- */
  function initViewers() {
    var nodes = document.querySelectorAll('[data-viewers]:not([data-v-ready])');
    Array.prototype.forEach.call(nodes, function (v) {
      v.setAttribute('data-v-ready', '1');
      setInterval(function () {
        var n = parseInt(v.textContent, 10) || 37;
        n += Math.random() > 0.5 ? 1 : -1;
        v.textContent = Math.max(24, Math.min(72, n));
      }, 4000);
    });
  }

  /* ---------- FAQ / Details ---------- */
  function initFaq() {
    Array.prototype.forEach.call(document.querySelectorAll('#faq details.acc'), function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          Array.prototype.forEach.call(document.querySelectorAll('#faq details.acc'), function (o) {
            if (o !== d) o.open = false;
          });
        }
      });
    });
  }

  function boot() {
    initCountdowns();
    initViewers();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme-Editor: Sections werden nachgeladen */
  document.addEventListener('shopify:section:load', boot);
})();

/* Mobile-Menü */
(function () {
  'use strict';
  function init() {
    var menu = document.getElementById('mobile-menu');
    var openBtn = document.getElementById('menu-open');
    var closeBtn = document.getElementById('menu-close');
    if (!menu || !openBtn || openBtn.getAttribute('data-mm-ready')) return;
    openBtn.setAttribute('data-mm-ready', '1');

    function open() {
      menu.hidden = false;
      document.body.classList.add('mm-open');
      openBtn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      document.body.classList.remove('mm-open');
      openBtn.setAttribute('aria-expanded', 'false');
    }

    openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.addEventListener('click', function (e) {
      if (e.target === menu) close();
      if (e.target.tagName === 'A') close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
